import type { Locale, RouteKind } from "../content/types";
import { LandingPage } from "./LandingPage";
import { PrivacyPage } from "./PrivacyPage";
import { SupportPage } from "./SupportPage";
import { TermsPage } from "./TermsPage";

/** 每种页面对应的组件，App 路由与预渲染共用。 */
export const pageByKind: Record<RouteKind, (props: { locale: Locale }) => JSX.Element> = {
  landing: LandingPage,
  privacy: PrivacyPage,
  support: SupportPage,
  terms: TermsPage
};
